import { render, staticRenderFns } from "./Door.vue?vue&type=template&id=c449ea50"
import script from "./Door.vue?vue&type=script&lang=js"
export * from "./Door.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports